import OrderSearch from "./search";
import Order from "./order";

export const routes = [

    {path: '/productless/find/order/search', name:'productless.order.search', component:OrderSearch},
    {path: '/productless/find/order/search/:order', name:'productless.order.search.order', component:OrderSearch},
    {path: '/productless/find/order', name:'productless.order', component:Order},

];
